import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react';
import BrowseMapOnboarding from './BrowseMapOnboarding';
import AddPlaceOnboarding from './AddPlaceOnboarding';

const TOUR_FLOWS = {
  browse: 'browse',
  addPlace: 'addPlace',
};

const OnboardingTour = forwardRef(({
  activeFlow,
  hasVisibleMarker,
  onEnd,
  addPlaceButtonRef,
  timelineSliderRef,
  mapRef,
}, ref) => {
  const [timelineReady, setTimelineReady] = useState(false);
  const [mapReady, setMapReady] = useState(false);

  useEffect(() => {
    if (activeFlow !== TOUR_FLOWS.browse) {
      setTimelineReady(false);
      setMapReady(false);
      return undefined;
    }
    if (timelineSliderRef?.current) {
      setTimelineReady(true);
    }
    if (mapRef?.current?.getContainer?.()) {
      setMapReady(true);
    }
    const id = window.setInterval(() => {
      if (timelineSliderRef?.current) {
        setTimelineReady(true);
      }
      if (mapRef?.current?.getContainer?.()) {
        setMapReady(true);
      }
    }, 150);
    return () => clearInterval(id);
  }, [activeFlow, timelineSliderRef, mapRef]);

  const [addPlaceReady, setAddPlaceReady] = useState(false);

  useEffect(() => {
    if (activeFlow !== TOUR_FLOWS.addPlace) {
      setAddPlaceReady(false);
      return undefined;
    }
    if (addPlaceButtonRef?.current) {
      setAddPlaceReady(true);
    }
    const id = window.setInterval(() => {
      if (addPlaceButtonRef?.current) {
        setAddPlaceReady(true);
      }
    }, 150);
    return () => clearInterval(id);
  }, [activeFlow, addPlaceButtonRef]);

  useImperativeHandle(ref, () => ({
    advanceStep() {
      /* legacy no-op — tours end via MapComponent interactions */
    },
  }));

  const showBrowseOnboarding =
    activeFlow === TOUR_FLOWS.browse && timelineReady && mapReady && timelineSliderRef?.current;

  const showAddPlaceOnboarding =
    activeFlow === TOUR_FLOWS.addPlace && addPlaceReady && addPlaceButtonRef?.current;

  return (
    <>
      {showBrowseOnboarding && (
        <BrowseMapOnboarding
          visible
          timelineRef={timelineSliderRef}
          mapRef={mapRef}
          hasVisibleMarker={hasVisibleMarker}
        />
      )}
      {showAddPlaceOnboarding && (
        <AddPlaceOnboarding visible buttonRef={addPlaceButtonRef} />
      )}
    </>
  );
});

export { TOUR_FLOWS };
export default React.memo(OnboardingTour);
